import { uuid } from '@elfsight/lib-utils';

const BOOKING_SESSION_KEY = 'AppointmentBooking.session';

export const getSessionId = () => {
  try {
    const storedSessionId = window.localStorage.getItem(BOOKING_SESSION_KEY);

    if (!storedSessionId) {
      const nextSessionId = uuid();
      window.localStorage.setItem(BOOKING_SESSION_KEY, nextSessionId);
      return nextSessionId;
    }

    return storedSessionId;
  } catch (e) {
    return 'NULL';
  }
};
